import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps, setDisplayName } from 'recompose';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Text = function Text(_ref) {
  var element = _ref.element,
      children = _ref.children,
      className = _ref.className,
      typeStyle = _ref.typeStyle,
      fixed = _ref.fixed,
      rest = _objectWithoutPropertiesLoose(_ref, ["element", "children", "className", "typeStyle", "fixed"]);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: classnames(typeStyle && "ln-u-" + typeStyle + (fixed ? '-fixed' : ''), className)
  }), children);
};

Text.propTypes = {
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  children: PropTypes.node,
  className: PropTypes.string,
  typeStyle: PropTypes.string,
  fixed: PropTypes.bool
};
Text.defaultProps = {
  element: 'span',
  children: undefined,
  className: undefined,
  typeStyle: undefined,
  fixed: false
};
Text.displayName = 'Text';

var Heading = function Heading(_ref) {
  var children = _ref.children,
      element = _ref.element,
      level = _ref.level,
      typeStyle = _ref.typeStyle,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "element", "level", "typeStyle"]);

  var props = {};
  var hElement = element || "h" + level;

  if (typeof hElement !== 'string' || !/h[1-6]/i.test(hElement)) {
    props = {
      role: 'heading',
      'aria-level': level,
      typeStyle: typeStyle || "h" + level
    };
  }

  return /*#__PURE__*/React.createElement(Text, _extends({}, rest, {
    typeStyle: typeStyle,
    element: hElement
  }, props), children);
};

Heading.propTypes = {
  children: PropTypes.node,
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  level: PropTypes.number,
  typeStyle: PropTypes.string
};
Heading.defaultProps = {
  children: undefined,
  element: undefined,
  level: 1,
  typeStyle: undefined
};
Heading.displayName = 'Heading';

var createHeadingVariants = function createHeadingVariants(level) {
  return compose(setDisplayName("Heading" + level), withProps({
    level: level
  }))(Heading);
};
/** @component */


var Heading1 = createHeadingVariants(1);
/** @component */

var Heading2 = createHeadingVariants(2);
/** @component */

var Heading3 = createHeadingVariants(3);
/** @component */

var Heading4 = createHeadingVariants(4);
/** @component */

var Heading5 = createHeadingVariants(5);
/** @component */

var Heading6 = createHeadingVariants(6);

var getDisplayName = function getDisplayName(typeStyle) {
  return "" + typeStyle.charAt(0).toUpperCase() + typeStyle.substring(1).replace('-', '');
};

var createTypeStyleVariant = function createTypeStyleVariant(typeStyle) {
  return compose(setDisplayName(getDisplayName(typeStyle)), withProps({
    typeStyle: typeStyle
  }))(Text);
};
/** @component */


var Body1 = createTypeStyleVariant('body-1');
/** @component */

var Body2 = createTypeStyleVariant('body-2');
/** @component */

var ButtonText = createTypeStyleVariant('button');
/** @component */

var Caption = createTypeStyleVariant('caption');
/** @component */

var Display1 = createTypeStyleVariant('display-1');
/** @component */

var Display2 = createTypeStyleVariant('display-2');
/** @component */

var Display3 = createTypeStyleVariant('display-3');
/** @component */

var Display4 = createTypeStyleVariant('display-4');
/** @component */

var Display5 = createTypeStyleVariant('display-5');
/** @component */

var Display6 = createTypeStyleVariant('display-6');
/** @component */

var Display7 = createTypeStyleVariant('display-7');
export { Text, Heading, Heading1, Heading2, Heading3, Heading4, Heading5, Heading6, Body1, Body2, ButtonText, Caption, Display1, Display2, Display3, Display4, Display5, Display6, Display7 };